/*
 * Authors: mariushirjanu
 * Created: 05/12/2022
 * Reference: https://github.com/wnr/element-resize-detector
 */

import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import * as elementResizeDetectorMaker from 'element-resize-detector';

@Injectable()
export class ResizeService {
  private resizeDetector:elementResizeDetectorMaker;

  constructor() {
    this.resizeDetector = elementResizeDetectorMaker({ strategy: 'scroll' });
  }

  public addResizeEventListener(element:string|HTMLElement, handler:Function) {
    if(this.getElement(element)){
      this.resizeDetector.listenTo(this.getElement(element), handler);
    }
  }

  public removeResizeEventListener(element:string|HTMLElement) {
    this.resizeDetector.uninstall(element);
  }

  public getElement(element:string|HTMLElement){
    return _.isString(element) ? document.getElementById(element) : element;
  }
}